/**
 * Checks if a fuel type value represents electric or hybrid vehicle
 *
 * @param fuelType - Fuel type value (can be from array or single value)
 * @returns true if fuel type is FUELTYPE_ELECTRIC or FUELTYPE_HYBRID
 *
 * @example
 * // From array (form state)
 * isElectricOrHybridFuelType(formData.fuelType?.at(0))
 *
 * // From single value
 * isElectricOrHybridFuelType(previousFuelType)
 */
export const isElectricOrHybridFuelType = (fuelType: string | null | undefined): boolean =>
  fuelType === 'FUELTYPE_ELECTRIC' || fuelType === 'FUELTYPE_HYBRID';
